import { FC, useState } from 'react';
import clsx from 'clsx';
import { Icon } from '@marriott/mi-ui-library';

import { StyledWalletAwardTile } from './WalletAwardTile.styles';
import { WalletAwardTileProps } from './WalletAwardTile.types';

const noop = () => {};

export const WalletAwardTile: FC<WalletAwardTileProps> = ({
  eyebrow,
  title,
  expirationText,
  statusLabel,
  statusVariant = 'neutral',
  statusIconClass,
  mediaVariant,
  mediaIconClass,
  mediaIconColor,
  mediaImageSrc,
  mediaImageAltText,
  onClick,
  ariaLabel,
  testId,
  trackingProperties,
  customClickTrackValue,
}) => {
  const [hasImageError, setHasImageError] = useState(false);
  const derivedVariant: 'icon' | 'image' = mediaVariant ? mediaVariant : mediaImageSrc ? 'image' : 'icon';
  const shouldRenderImage = derivedVariant === 'image' && Boolean(mediaImageSrc) && !hasImageError;
  const mediaModifierClass = shouldRenderImage ? 'wallet-award-tile__media--image' : 'wallet-award-tile__media--icon';

  return (
    <StyledWalletAwardTile data-testid={testId}>
      <button
        type="button"
        className={clsx('wallet-award-tile__button', customClickTrackValue && 'custom_click_track')}
        onClick={onClick || noop}
        aria-label={ariaLabel || title}
        data-custom_click_track_value={customClickTrackValue}
        data-tracking-content-position={trackingProperties?.trackingContentPosition}
        data-tracking-description={trackingProperties?.trackingDescription}
        data-is-click-track={trackingProperties?.clickTrack}
      >
        <div className="wallet-award-tile__card">
          <div className={clsx('wallet-award-tile__media', mediaModifierClass)} aria-hidden="true">
            {shouldRenderImage ? (
              <img
                className="wallet-award-tile__media-image"
                src={mediaImageSrc}
                alt={mediaImageAltText || ''}
                onError={() => setHasImageError(true)}
              />
            ) : mediaIconClass ? (
              <span
                className="wallet-award-tile__media-icon"
                style={mediaIconColor ? { color: mediaIconColor } : undefined}
              >
                <Icon iconClass={mediaIconClass} isDecorative />
              </span>
            ) : (
              <span className="wallet-award-tile__media-placeholder" />
            )}
          </div>
          <div className="wallet-award-tile__content">
            {eyebrow ? <div className="wallet-award-tile__eyebrow">{eyebrow}</div> : null}
            <div className="wallet-award-tile__title" title={title}>
              {title}
            </div>
            {expirationText ? <div className="wallet-award-tile__expiration">{expirationText}</div> : null}
            {statusLabel ? (
              <div className={clsx('wallet-award-tile__status', `wallet-award-tile__status--${statusVariant}`)}>
                {statusIconClass ? (
                  <Icon
                    iconClass={clsx('wallet-award-tile__status-icon', 'icon-decorative', statusIconClass)}
                    isDecorative
                  />
                ) : null}
                <span className="wallet-award-tile__status-text">{statusLabel}</span>
              </div>
            ) : null}
          </div>
          <span className="wallet-award-tile__chevron" aria-hidden="true">
            <Icon iconClass="icon-decorative icon-arrow-right" isDecorative ariaLabel="" />
          </span>
        </div>
      </button>
    </StyledWalletAwardTile>
  );
};
